let currencySymbol = '$';
if (theme.settings.storeCurrency && Shopify) {
  const { currency: { active } } = Shopify;
  const { storeCurrency } = theme.settings;
  const current = storeCurrency.find(({ ISO }) => ISO === active );
  if (current) currencySymbol = current.symbol;
}

const moneyFormat = (amount) => {
  return `${currencySymbol}${(amount / 100).toFixed(2)}`;
}

const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const fetchCart = async () => {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    if (res.ok) return data;
  } catch (error) {
    console.log(error);
    return null
  }
}

class CartThreshold extends HTMLElement {
    constructor() {
      super();
  
      this.freeGiftTagPrefix = '_free-gift:';
      this.enabledTargets = [];
      this.maxTarget = 0;
  
      this.script = this.querySelector('script');
      this.data = this.script ? JSON.parse(this.script.textContent) : null;
      this.enabled = this.data ? this.data.settings.enabled : null;
      if (!this.data || !this.enabled) return;
  
      const [ freeShipping, expressShipping, freeGift ] = this.data.targets;
      if (freeShipping.value > 0) {
        this.enabledTargets.push(freeShipping);
      }
      if (expressShipping.value > 0) {
        this.enabledTargets.push(expressShipping);
      }
      if(freeGift.product) {
        const tag = freeGift.product.tags.find((tag) => tag.includes(this.freeGiftTagPrefix));
        const value = tag ? +tag.replace(this.freeGiftTagPrefix, '') : 0;
        if (freeGift.product.available && value > 0) {
          Object.assign(freeGift, {
            title: freeGift.product.title,
            value
          });
          this.enabledTargets.push(freeGift);
        } else {
          console.log('Free gift product not available', freeGift.product );
        }
      }
  
      if (!this.enabledTargets.length) return;
      this.enabledTargets = this.enabledTargets.sort((a, b) => a.value - b.value);
  
      const allTargets = this.enabledTargets.map(({ value }) => value);
      this.maxTarget = Math.max(...allTargets);
      if (this.maxTarget === 0) return;
  
      this.#renderElements();
      this.#init();
  
      document.addEventListener('cart:updated', (evt) => {
        const { detail: { cart } } = evt;
        this.#calculateShipping(cart);
      });
    }
  
    #convertToCurrency(amount) {
      return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * +amount) : Math.trunc(+amount)
    }
  
    async #init() {
      const cartData = await fetchCart();
      this.#calculateShipping(cartData);
    }
  
    #renderElements() {
      const target= this.#convertToCurrency(this.maxTarget);
      const renderProgressDots = this.enabledTargets.map(({ name, label, value }, index) => {
        if(name == 'free-gift') {
          return `
            <span
              class="promo-dots promo--${name} promo--${name}-${index}"
              data-target="${value}"
              data-currency-symbol="${currencySymbol}"
              data-label="${label}"
              aria-hidden="true"
              style="--position: ${(value/this.maxTarget) * 100}"
              data-arkhi-freegift-threshold="${value}"
              data-arkhi-freegift-title="${theme.settings.freeGiftProduct.title}">
            </span>
          `
        } else {
          return `
            <span
              class="promo-dots promo--${name} promo--${name}-${index}"
              data-target="${value}"
              data-currency-symbol="${currencySymbol}"
              data-label="${label}"
              aria-hidden="true"
              style="--position: ${(value/this.maxTarget) * 100}">
            </span>
          `
        }
      }).join('');
  
      const html = `
        <div class="cart-promotions-wrapper" data-target="${target}" data-currency-symbol="${currencySymbol}">
          <label for="cart-promotions" class="visually-hidden">Cart Promotions</label>
          <progress id="cart-promotions" max="100" value="0" data-target="${target}"></progress>
          <span class="promo-dots promo--value"></span>
          ${renderProgressDots}
        </div>
        <div id="cart-promotions-message" class="cart-promotions-message"></div>
      `;
  
      this.innerHTML = html;
    }
  
    #calculateShipping(cartJson) {
      const targets = this.enabledTargets;
      const total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : cartJson.final_price && cartJson.final_price > 0 ? cartJson.final_price : 0;
      const cartTotal = total > 0 ? total / 100 : 0;
      const progressValue = (cartTotal / this.#convertToCurrency(this.maxTarget)) * 100;
      const container = document.getElementById('cart-promotions');
      let message = '';
  
      if (progressValue >= 100) {
        container.setAttribute('value', 100);
        container.parentElement.setAttribute('value', 100);
      } else {
        container.setAttribute('value', progressValue ? progressValue : 0);
        container.parentElement.setAttribute('value', progressValue ? progressValue : 0);
      }
  
      if (this.querySelector('.promo--value')) {
        this.querySelector('.promo--value').style.setProperty('--position', progressValue > 100 ? 100 : progressValue);
      }
  
      if (!this.maxTarget) {
        message = 'Please enter target amounts in Theme Settings > Cart Promotions'
        return;
      }
  
      if (cartTotal <= 0) {
        message = this.data.settings.default;
      } else {
        for (const [index, target] of targets.entries()) {
          const promoDot = this.querySelector(`.promo--${target.name}-${index}`);
          const remaining = this.#convertToCurrency(target.value) - cartTotal;
  
          if (remaining <= 0) {
            message = `<span>${target.messaging.success.replaceAll('[title]', target.title ?? '')}</span><br/>` ?? '';
            if (promoDot) promoDot.classList.add('active');
          } else {
            message += target.messaging.ongoing.replace('[remaining]', `<strong>${currencySymbol}${remaining ? remaining.toFixed(2) : target.value.toFixed(2)}</strong>`).replaceAll('[title]', target.title ?? '') ?? '';
            if (promoDot) promoDot.classList.remove('active');
            break;
          }
        }
      }
      // Display message
      document.getElementById('cart-promotions-message').innerHTML = message;
    }
}

customElements.define('widget-cart-threshold', CartThreshold);